module.exports = __webpack_public_path__ + "static/img/88-2.4479e7d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/88-2.jpg
// module id = Ssgw
// module chunks = 0